import { c as _c } from "react/compiler-runtime";
import { Textarea } from '@xefi/x-react/form';
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import { type ChangeEventHandler, type ComponentProps, useEffect, useState } from 'react';
type TextareaWithMaxLengthProps = ComponentProps<typeof Textarea> & {
  maxLength: number;
  containerClassName?: string;
};
export const TextareaWithMaxLength = t0 => {
  const $ = _c(49);
  let classNames;
  let containerClassName;
  let defaultValue;
  let maxLength;
  let onChange;
  let rest;
  let value;
  if ($[0] !== t0) {
    ({
      containerClassName,
      maxLength,
      value,
      defaultValue,
      classNames,
      onChange,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = classNames;
    $[2] = containerClassName;
    $[3] = defaultValue;
    $[4] = maxLength;
    $[5] = onChange;
    $[6] = rest;
    $[7] = value;
  } else {
    classNames = $[1];
    containerClassName = $[2];
    defaultValue = $[3];
    maxLength = $[4];
    onChange = $[5];
    rest = $[6];
    value = $[7];
  }
  const isControlled = typeof value !== "undefined";
  let t1;
  if ($[8] !== defaultValue || $[9] !== isControlled || $[10] !== value) {
    t1 = () => isControlled ? String(value ?? "") : String(defaultValue ?? "");
    $[8] = defaultValue;
    $[9] = isControlled;
    $[10] = value;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  const [internalValue, setInternalValue] = useState(t1);
  const currentString = isControlled ? String(value ?? "") : internalValue;
  const currentLength = currentString.length;
  const isLimitReached = currentLength >= maxLength;
  let t2;
  if ($[12] !== isControlled || $[13] !== onChange) {
    t2 = event => {
      if (!isControlled) {
        setInternalValue(event.target.value);
      }
      onChange?.(event);
    };
    $[12] = isControlled;
    $[13] = onChange;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const handleChange = t2;
  let t3;
  let t4;
  if ($[15] !== defaultValue || $[16] !== isControlled) {
    t3 = () => {
      if (!isControlled) {
        setInternalValue(String(defaultValue ?? ""));
      }
    };
    t4 = [defaultValue, isControlled];
    $[15] = defaultValue;
    $[16] = isControlled;
    $[17] = t3;
    $[18] = t4;
  } else {
    t3 = $[17];
    t4 = $[18];
  }
  useEffect(t3, t4);
  let t5;
  if ($[19] !== containerClassName) {
    t5 = mergeTailwindClasses("relative", containerClassName);
    $[19] = containerClassName;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const t6 = classNames?.inputWrapper;
  const t7 = maxLength > 99 && "pr-[62px]";
  const t8 = maxLength > 999 && "pr-[72px]";
  let t9;
  if ($[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = mergeTailwindClasses(t6, "pr-[52px]", t7, t8);
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== classNames || $[26] !== t9) {
    t10 = {
      ...classNames,
      inputWrapper: t9,
      input: "text-sm"
    };
    $[25] = classNames;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== defaultValue || $[29] !== handleChange || $[30] !== maxLength || $[31] !== rest || $[32] !== t10 || $[33] !== value) {
    t11 = <Textarea value={value} defaultValue={defaultValue} onChange={handleChange} classNames={t10} maxLength={maxLength} {...rest} />;
    $[28] = defaultValue;
    $[29] = handleChange;
    $[30] = maxLength;
    $[31] = rest;
    $[32] = t10;
    $[33] = value;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  const t12 = isLimitReached ? "text-primary" : "text-content1-400";
  let t13;
  if ($[35] !== t12) {
    t13 = mergeTailwindClasses("absolute right-1.5 bottom-1 text-right text-xs", t12);
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== currentLength) {
    t14 = <span>{currentLength}</span>;
    $[37] = currentLength;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== maxLength) {
    t15 = <span>{maxLength}</span>;
    $[39] = maxLength;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t13 || $[42] !== t14 || $[43] !== t15) {
    t16 = <div className={t13} role="status" aria-live="polite">{t14}{"/"}{t15}</div>;
    $[41] = t13;
    $[42] = t14;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t11 || $[46] !== t16 || $[47] !== t5) {
    t17 = <div className={t5}>{t11}{t16}</div>;
    $[45] = t11;
    $[46] = t16;
    $[47] = t5;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  return t17;
};